import type { OverviewSeriesMap } from '../models/overview.types'

import { isRangeEndToday } from './isRangeEndToday'

function cloneSeriesMap(source: OverviewSeriesMap): OverviewSeriesMap {
  return Object.fromEntries(
    Object.entries(source).map(([key, series]) => [
      key,
      { ...series, current: { ...series.current }, before: { ...series.before } },
    ]),
  )
}

/**
 * Return a forecast copy with today's eligible actual points overlaid. Inputs remain immutable;
 * the date eligibility is the exact legacy today/yesterday rule.
 */
export function mergeForecastIntoActual(
  forecast: OverviewSeriesMap,
  actual: OverviewSeriesMap,
  queryString: string | null,
  now: Date = new Date(),
): OverviewSeriesMap {
  const merged = cloneSeriesMap(forecast)
  const rangeEnd = isRangeEndToday({ queryString, now, returnMode: true })

  for (const [key, actualSeries] of Object.entries(actual)) {
    const target = merged[key]?.current
    if (!target) continue
    for (const [date, value] of Object.entries(actualSeries.current)) {
      if (isRangeEndToday({ date, now, onlyToday: rangeEnd === 'today' })) {
        target[date] = value
      }
    }
  }
  return merged
}
